// Paleta categórica validada (ordem fixa, 10 pares borda/fundo pastel) para
// diferenciar matérias visualmente por cor. Fonte única — reaproveitada pelo
// calendário do Plano de Estudos Personalizado (StudyPlanCalendar.js) e pelo
// Progresso do edital (EditalProgressPanel.js), para as duas telas usarem a
// mesma linguagem visual em vez de paletas distintas.
export const SUBJECT_COLOR_PALETTE = [
  { border: '#3B6FD6', bg: '#E9EFFC' },
  { border: '#DB7A3A', bg: '#FBEEE0' },
  { border: '#2F9E6E', bg: '#E4F5EE' },
  { border: '#D5487A', bg: '#FBE7EE' },
  { border: '#7C5CD1', bg: '#EFEAFB' },
  { border: '#2596A6', bg: '#E3F3F5' },
  { border: '#C99A2E', bg: '#FBF3E1' },
  { border: '#C2492F', bg: '#FAE7E2' },
  { border: '#7A8C3A', bg: '#F1F4E4' },
  { border: '#52667D', bg: '#E9EDF1' }
];

export const getSubjectColor = (index) =>
  SUBJECT_COLOR_PALETTE[index % SUBJECT_COLOR_PALETTE.length];

export const hexToRgba = (hex, alpha) => {
  const value = hex.replace('#', '');
  const r = parseInt(value.substring(0, 2), 16);
  const g = parseInt(value.substring(2, 4), 16);
  const b = parseInt(value.substring(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
